import { render, staticRenderFns } from "./TerminalAuthorizationEdit.vue?vue&type=template&id=0af767e6&scoped=true&"
import script from "./TerminalAuthorizationEdit.vue?vue&type=script&lang=js&"
export * from "./TerminalAuthorizationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af767e6",
  null
  
)

export default component.exports